/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamRevisionLangBotexamlangidTranslation200,
  GetApiV1ExamRevisionLangBotexamlangidTranslation401,
  GetApiV1ExamRevisionLangBotexamlangidTranslation404,
  GetApiV1ExamRevisionLangBotexamlangidTranslation500,
  GetApiV1ExamRevisionLangBotexamlangidTranslationPathParams,
  GetApiV1ExamRevisionLangBotexamlangidTranslationQueryParams,
  GetApiV1ExamRevisionLangBotexamlangidTranslationQueryResponse,
} from "../../types/examRevisionController/GetApiV1ExamRevisionLangBotexamlangidTranslation.ts";
import { botExamLangTranslationViewModelSchema } from "../botExamLangTranslationViewModelSchema.ts";

export const getApiV1ExamRevisionLangBotexamlangidTranslationPathParamsSchema =
  z.object({
    botExamLangId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1ExamRevisionLangBotexamlangidTranslationPathParams>;

export const getApiV1ExamRevisionLangBotexamlangidTranslationQueryParamsSchema =
  z.object({
    pageNumber: z.coerce.number().int().default(1),
    pageSize: z.coerce.number().int().default(1),
  }) as unknown as ToZod<GetApiV1ExamRevisionLangBotexamlangidTranslationQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamRevisionLangBotexamlangidTranslation200Schema = z.lazy(
  () => botExamLangTranslationViewModelSchema,
) as unknown as ToZod<GetApiV1ExamRevisionLangBotexamlangidTranslation200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamRevisionLangBotexamlangidTranslation401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamRevisionLangBotexamlangidTranslation401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ExamRevisionLangBotexamlangidTranslation404Schema =
  z.any() as unknown as ToZod<GetApiV1ExamRevisionLangBotexamlangidTranslation404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamRevisionLangBotexamlangidTranslation500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamRevisionLangBotexamlangidTranslation500>;

export const getApiV1ExamRevisionLangBotexamlangidTranslationQueryResponseSchema =
  z.lazy(
    () => getApiV1ExamRevisionLangBotexamlangidTranslation200Schema,
  ) as unknown as ToZod<GetApiV1ExamRevisionLangBotexamlangidTranslationQueryResponse>;
